export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="sticky top-28">
            <div className="overline overline-red mb-6">01 — About</div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.95]">
              Operational
              <br />
              experience.
              <br />
              <span className="text-[#d92d20]">Research-driven</span>
              <br />
              insight.
            </h2>

            <div className="mt-10 border border-[#262626] p-1 inline-block">
              <img
                src="https://customer-assets.emergentagent.com/job_emergency-expert-1/artifacts/j4enmwuc_Headshot.jpg"
                alt="Dr. Cj Avory"
                data-testid="about-headshot"
                className="w-full max-w-[360px] grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-6 text-white/80 text-[15px] sm:text-base leading-relaxed">
          <p>
            <span className="text-white font-semibold">Dr. Cj Avory</span> is an
            emergency management executive, author, and leadership consultant with
            more than 20 years of experience in emergency management, public safety,
            preparedness, and crisis response. She leads countywide initiatives
            focused on preparedness, response, recovery, continuity, and resilience.
          </p>
          <p>
            Prior to her current role, Dr. Avory held leadership positions in higher
            education emergency management and spent more than a decade in law
            enforcement and emergency services. Throughout her career, she has
            focused on helping organizations strengthen decision-making, improve
            operational readiness, and build resilience before crises occur.
          </p>
          <p>
            Dr. Avory holds a <span className="text-white">Doctor of Management in
            Homeland Security</span> and is the author of{" "}
            <span className="text-white italic">Decision Margin: Why Organizations
            Fail Before the Crisis Hits</span>. Her work examines leadership under
            pressure, organizational resilience, crisis management, and the factors
            that determine whether organizations succeed or fail during times of
            disruption.
          </p>
          <p>
            Through consulting, training, and speaking engagements, Dr. Avory helps
            leaders navigate uncertainty, manage risk, and build organizations that
            can adapt and perform under challenging conditions. Her practical
            approach combines real-world operational experience with research-driven
            insights, making complex concepts accessible and actionable for leaders
            at every level.
          </p>

          <div className="mt-12 grid grid-cols-2 gap-px bg-[#262626] border border-[#262626]">
            <Fact k="Role" v="Emergency Management Executive" />
            <Fact k="Credential" v="Doctor of Management, Homeland Security" />
            <Fact k="Focus" v="Crisis Leadership · Resilience · Decision-Making" />
            <Fact k="Sectors" v="Gov · Healthcare · Higher Ed · Public Safety" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Fact({ k, v }) {
  return (
    <div className="bg-[#0a0a0a] p-6">
      <div className="overline mb-2">{k}</div>
      <div className="text-white text-sm font-medium leading-snug">{v}</div>
    </div>
  );
}
